import type { Language } from "@helpers/I18nHelper";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LanguageStore {
  language: undefined | Language;
  hasUserSelectedALanguage: boolean;
  setLanguage: (language?: Language) => void;
  selectLanguage: (language?: Language) => void;
}

const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      language: undefined,
      hasUserSelectedALanguage: false,
      // Set is used to force the language
      setLanguage: (language) => {
        set({ language });
      },
      // Select means the user choose the language manually
      // This is to correctly trigger the language modal
      selectLanguage: (language) => {
        set({ language, hasUserSelectedALanguage: true });
      },
    }),
    { name: "SecretSmurfsStoreLanguage" },
  ),
);

export default useLanguageStore;

export const hasUserSelectedALanguage = (): boolean => {
  const { language } = useLanguageStore();

  return !!language;
};

/**
 * This is not a hook, and should only be used outside of react components
 */
export const getSelectedLanguage = () => {
  return useLanguageStore.getState().language;
};
